const progressOrder = {
    critical: 0,
    minor: 1,
    notable: 2,
    resolved: 3,
};
export const compareProgress = (a, b) => progressOrder[a] - progressOrder[b];
